<header class="header-area">
    <div class="top-header">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-lg-4 col-md-12">
                    <ul class="header-contact-info">
                        <li>
                            <div class="dropdown language-switcher d-inline-block">
                                <button class="dropdown-toggle" type="button" (click)="toggleClassLang()">
                                    <img src="{{CurrentLangSrc}}" alt="image">
                                    <span>{{CurrentLangName}} <i class='bx bx-chevron-down'></i></span>
                                </button>
                                <div class="dropdown-menu" [class.active]="classApplied">
                                    <button (click)="setLang()" class="dropdown-item d-flex align-items-center">
                                        <img src="{{SecondLangSrc}}" class="shadow-sm" alt="flag">
                                        <span>{{SecondLangName}}</span>
                                    </button>

                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="dropdown currency-switcher d-inline-block">
                                <button class="dropdown-toggle" type="button" (click)="toggleClassCurr()">
                                    <span>{{CurrentCurrencyName}} <i class='bx bx-chevron-down'></i></span>
                                </button>
                                <div class="dropdown-menu" [class.active]="classAppliedCurr">
                                    <button (click)="setCurrency(true)" class="dropdown-item d-flex align-items-center">
                                        <span>{{SecondCurrencyName}}</span>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-4 col-md-12">
                    <div class="top-header-discount-info">

                    </div>
                </div>
                <div class="col-lg-4 col-md-12">
                    <ul class="header-top-menu">

                        <!--<li>{{'OperatorHeader_TXT' | translate }}</li>-->
                    </ul>

                </div>
            </div>
        </div>
    </div>
    <div class="navbar-area">
        
        <div *ngIf="!isSmallScreen" class="louise-nav">
            <!--[ngClass]="isSmallScreen ? 'container-fluid-small' : 'container-fluid'"-->
            <div class="container-fluid">
                <nav class="navbar navbar-expand-sm navbar-light" style="justify-content: space-between; align-items: center;">
                    <a class="navbar-brand" routerLink="/">
                        <!--<img src="assets/img/Logo_Color_B.png" alt="logo">-->
                        <img src="https://hekaya.s3.ap-south-1.amazonaws.com/carRental/logo-left1.png" width="70px" height="70px" alt="logo" loading="lazy">
                    </a>


                    <!------------------------------------------------------------------->
                    <div>
                        <div class="d-flex align-items-center justify-content-center h-100">
                            <div class="d-flex justify-content-center align-items-center newair">

                                <button class="linkbtn" (click)="openVisaDialog()">{{'Apply_For_Visa' | translate }}</button>

                                <button class="airsearch ml-2" (click)="openVisaDialog()">
                                    <i class='bx bx-search'></i>

                                </button>
                            </div>
                        </div>
                    </div>




                    <!------------------------------------------------------------------->

                    <div class="" style="width: auto; justify-content: end;">


                        <div class="others-option d-flex justify-content-end align-items-end" style="justify-content: end;">

                            <div class="col-lg-4 col-6 d-flex align-items-center justify-content-end">

                                <div class="d-flex align-items-center">

                                    <div *ngIf="isSmallScreen" style="width:auto; background-color: aquamarine;">
                                        <div class="d-flex align-items-center justify-content-center h-100" style="width:auto;">
                                            <div class="d-flex justify-content-center align-items-center newair-small" style="width:auto;">

                                                <button class="linkbtn" (click)="openVisaDialog()">{{'Apply_For_Visa' | translate }}</button>

                                                <button class="airsearch ml-2" (click)="openVisaDialog()">
                                                    <i class='bx bx-search'></i>

                                                </button>
                                            </div>
                                        </div>
                                    </div>



                                    <a routerLink="/tracking" class="d-flex" style="width: 140px;" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><i class='bx bx-location-plus bx-sm'></i>{{'Track_Application' | translate }}</a>



                                    <div class="option-item">
                                        <button type="button" class="dropdown-toggle" data-toggle="dropdown"
                                                aria-expanded="false">
                                            <i class='bx bx-menu bx-md'></i>

                                        </button>

                                        <div class="dropdown-menu dropdown-menu-right pt-0 pb-0">
                                            <ul class="list-group">
                                                <li class="list-group-item">
                                                    <a href="javascript:void(0)"
                                                       routerLink="/home">
                                                        {{'Home' | translate }}
                                                    </a>

                                                </li>
                                                <li class="list-group-item">
                                                    <a href="javascript:void(0)"
                                                       routerLink="/about-us">
                                                        {{'About_Us' | translate }}
                                                    </a>

                                                </li>

                                                <li class="list-group-item">
                                                    <a href="javascript:void(0)"
                                                       routerLink="/services">
                                                        {{'Services' | translate }}
                                                    </a>

                                                </li>

                                                <li class="list-group-item">
                                                    <a href="javascript:void(0)"
                                                       routerLink="/contact">
                                                        {{'Contact' | translate }}
                                                    </a>

                                                </li>
                                            </ul>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>

            </div>
        </div>

        <div *ngIf="isSmallScreen" class="louise-nav-small">
            <div class="container-fluid-small">
                <a class="navbar-brand" style="background-color: rosybrown;" routerLink="/">
                    <img src="https://hekaya.s3.ap-south-1.amazonaws.com/carRental/logo-left1.png" width="70px" height="70px" alt="logo" loading="lazy">
                </a>


                <div style="width:auto;">
                    <div class="d-flex align-items-center justify-content-center h-100" style="width:auto;">
                        <div class="d-flex justify-content-center align-items-center newair-small" style="width:auto;">

                            <button class="linkbtn" (click)="openVisaDialog()">{{'Apply_For_Visa' | translate }}</button>

                            <button class="airsearch ml-2" (click)="openVisaDialog()">
                                <i class='bx bx-search'></i>

                            </button>
                        </div>
                    </div>
                </div>

                <div class="options">
                    <div class="option-item">
                        <button type="button" class="dropdown-toggle" (click)="toggleDropdown()">
                            <i class='bx bx-menu bx-md'></i>

                        </button>

                        <div class="dropdown-menu dropdown-menu-right pt-0 pb-0" [class.show]="isDropdownOpen">
                            <ul class="list-group">
                                <li class="list-group-item">
                                    <a href="javascript:void(0)"
                                       routerLink="/home">
                                        {{'Home' | translate }}
                                    </a>

                                </li>
                                <li class="list-group-item">
                                    <a href="javascript:void(0)"
                                       routerLink="/about-us">
                                        {{'About_Us' | translate }}
                                    </a>

                                </li>

                                <li class="list-group-item">
                                    <a href="javascript:void(0)"
                                       routerLink="/services">
                                        {{'Services' | translate }}
                                    </a>

                                </li>

                                <li class="list-group-item">
                                    <a href="javascript:void(0)"
                                       routerLink="/contact">
                                        {{'Contact' | translate }}
                                    </a>

                                </li>
                            </ul>
                        </div>


                    </div>

                    <a routerLink="/tracking" class="d-flex" style="width: auto;" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><i class='bx bx-location-plus bx-sm'></i></a>
                </div>
                
            </div>
        </div>
    </div>
    </header>



<!--========================================================-->

<!--<div class="navbar-area">
    <div class="louise-responsive-nav">
        <div class="container">
            <div class="louise-responsive-menu">
                <div class="logo">
                    <a routerLink="/">
                        <img src="assets/img/logo.png" alt="logo">
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="louise-nav">
        <div class="container-fluid">
            <nav class="navbar navbar-expand-md navbar-light">
                <a class="navbar-brand" routerLink="/">
                    <img src="assets/img/logo.png" alt="logo">
                </a>

                <div class="collapse navbar-collapse mean-menu">
                    <ul class="navbar-nav">


                        <li class="nav-item"><a routerLink="/home" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Home' | translate }}</a></li>
                        <li class="nav-item"><a routerLink="/tracking" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Track_Application' | translate }}</a></li>
                        <li class="nav-item"><a routerLink="/about-us" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'About_Us' | translate }}</a></li>
                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Services' | translate }}</a></li>
                        <li class="nav-item"><a routerLink="/contact" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{'Contact' | translate }}</a></li>
                    </ul>

                    <div class="others-option">
                        <div class="d-flex align-items-center">

                            <div class="option-item">
                                <img src="assets/img/logo2.png" alt="logo">
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</div>-->
